// extracted by mini-css-extract-plugin
export default {"button":"Cz8eNn9a8W2CoFRMXejO"};